module.exports = __webpack_public_path__ + "static/img/8.27649d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/8.png
// module id = Iprb
// module chunks = 0